import React, { Component } from "react";
import { getAllIngredients, searchRecipesByIngredients } from "../../api/api";
import "./IngredientSearch.css";
import { withRouter } from "../../utils/withRouter";
class IngredientSearch extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ingredients: [],
      filteredIngredients: [],
      selectedIngredients: [],
      recipes: [],
      searchText: "",
      loading: true
    };
  }

  componentDidMount() {
    this.loadIngredients();
  }

  loadIngredients = async () => {
    try {

      const res = await getAllIngredients();

      this.setState({
        ingredients: res.data,
        filteredIngredients: res.data,
        loading: false
      });

    } catch (err) {
      console.log(err);
    }
  };

  handleSearch = (e) => {

    const value = e.target.value.toLowerCase();

    const filtered = this.state.ingredients.filter((item) =>
      item.ingredient_name.toLowerCase().includes(value)
    );

    this.setState({
      searchText: value,
      filteredIngredients: filtered
    });

  };

  toggleIngredient = async (name) => {

    let selected = [...this.state.selectedIngredients];

    if (selected.includes(name)) {
      selected = selected.filter((i) => i !== name);
    } else {
      selected.push(name);
    }

    this.setState({ selectedIngredients: selected });

    if (selected.length > 0) {

      const res = await searchRecipesByIngredients(selected);

      this.setState({
        recipes: res.data
      });

    } else {

      this.setState({
        recipes: []
      });

    }
  };

  clearAll = () => {

    this.setState({
      selectedIngredients: [],
      recipes: []
    });

  };

  goToRecipe = (recipe_id) => {

    this.props.router.navigate(`/RecipeDetails/${recipe_id}`);
  
  };
  render() {

    const {
      filteredIngredients,
      selectedIngredients,
      recipes,
      loading,
      searchText
    } = this.state;

    return (

      <div className="ingredient-page container-fluid py-5">

        <h2 className="text-center mb-4" id="search">
          Ingredient Recipe Search
        </h2>

        <p className="text-center">
          We assume you already have: oil, salt, water, sugar, pepper, cumin seeds, mustard seeds.
        </p>

        <div className="row">

          {/* LEFT COLUMN */}
          <div className="col-md-3">

            <h4>Select Ingredients</h4>

            {/* SEARCH BAR */}
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search ingredient..."
              value={searchText}
              onChange={this.handleSearch}
            />

            <div className="ingredient-list">

              {loading && <p>Loading ingredients...</p>}

              {filteredIngredients.map((item, index) => (

                <button
                  key={index}
                  className={`ingredient-pill ${
                    selectedIngredients.includes(item.ingredient_name)
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    this.toggleIngredient(item.ingredient_name)
                  }
                >
                  {item.ingredient_name}
                </button>

              ))}

            </div>

          </div>

          {/* PANTRY COLUMN */}
          <div className="col-md-3">

            <h4>Your Pantry</h4>

            <div className="pantry-box">

              {selectedIngredients.length === 0 && (
                <p>No ingredients selected</p>
              )}

              {selectedIngredients.map((item, i) => (
                <div key={i} className="pantry-item">
                  {item}
                </div>
              ))}

              {selectedIngredients.length > 0 && (
                <button
                  className="btn btn-danger mt-3"
                  onClick={this.clearAll}
                >
                  Clear All
                </button>
              )}

            </div>

          </div>

          {/* RECIPES COLUMN */}
          <div className="col-md-6">

            <h4>Recipes You Can Make</h4>

            {recipes.length === 0 && (
              <p>Select ingredients to see recipes</p>
            )}

            {recipes.map((recipe, index) => (

              <div key={index} className="card mb-3 shadow-sm"  
              onClick={() => this.goToRecipe(recipe.recipe_id)}>

                <div className="row g-0">

                  <div className="col-md-4">

                    <img
                      src={`https://flavoursnest-be.onrender.com/${recipe.recipe_image}`}
                      className="img-fluid rounded-start"
                      alt=""
                    />

                  </div>

                  <div className="col-md-8">

                    <div className="card-body">

                      <h5 className="card-title">
                        {recipe.recipe_title}
                      </h5>

                      <p>
                        Match: {recipe.matched_ingredients} / {recipe.total_ingredients}
                      </p>

                      <p className="text-success">
                        {recipe.match_percentage}% Match
                      </p>

                      {recipe.missing_ingredients.length > 0 && (
                        <p className="text-danger">
                          Missing: {recipe.missing_ingredients.join(", ")}
                        </p>
                      )}

                      <span className={`badge bg-${recipe.status === "perfect" ? "success" : "warning"}`}>
                        {recipe.status}
                      </span>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>

    );
  }
}

export default withRouter(IngredientSearch);